import { Breadcrumb, Button, Card, Form, Input, Modal, Select } from "antd";
import CallUsComponet from "../../components/callUs";
import { useCallback, useEffect, useState } from "react";
import AuthService from "../../services/auth.service";
import { profileDetailsSelector } from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {ReactComponent as TitleIcon } from "../../assests/images/sidebar/help.svg";
import { useTranslation } from "react-i18next";
import {ReactComponent as TickIcon} from "../../assests/images/tickIcon.svg";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import { allowOnlyAlphaNumericsShouldNotStartWithSpace } from "../../services/common.service";

export default function ContactUs() {
  const [form] = Form.useForm();
  const [selectedDetails, setSelectedDetails] = useState({});
  const [dataSource, setDataSource] = useState([]);
  const profileDetails = useSelector(profileDetailsSelector);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState("");
  const { t } = useTranslation();
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setFeedback(inputValue);
  };

  useEffect(() => {
    getFeedbackCategory();
  }, []);

  const getFeedbackCategory = useCallback(async () => {
    try {
      const response = await AuthService.getFeedbackCategory();
      if (response.status === "OK") {
        setDataSource(
          Object.entries(response.data.values).map(
            ([category, categoryEmail]) => ({
              category,
              categoryEmail,
            })
          )
        );
      }
    } catch (error) {}
  }, []);

  const createFeedback = useCallback(
    async (data) => {
      try {
        const req = {
          category: data.category,
          suggestion: data.suggestion,
          categoryEmail: selectedDetails.categoryEmail || "",
          emailId: profileDetails.emailId,
          mobile: profileDetails.mobileNo,
        };
        const response = await AuthService.createFeedback(req);
        if (response.status === "OK") {
          setMessage(response["message"]);
          setShowModal(true);
        }
      } catch (error) {}
    },
    [selectedDetails, profileDetails]
  );

  const categoryChange = (value) => {
    setSelectedDetails(dataSource.find((e) => e.category === value));
  };

  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> 
          <Breadcrumb.Item>
            <span>
              {t("navigation.contact", {
                defaultValue: "Contact Us",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginRight: "2%" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.contact", {
                defaultValue: "Contact Us",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <Card   className="application-card card-padding">
            <CallUsComponet />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <Card   className="application-card card-padding">
            <h5>
              {t("common.suggesion", {
                defaultValue: "Suggestions",
              })}
            </h5>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <Form layout="vertical" form={form} onFinish={createFeedback}>
                  <Form.Item
                    label={t("pages.security_questions.feed_back_cat", {
                      defaultValue: "Feedback Category",
                    })}
                    name={"category"}
                    rules={[
                      {
                        required: true,
                        message: t("pages.security_questions.feedbackcat_req", {
                          defaultValue: "Feedback Category is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("pages.security_questions.feed_back_cat", {
                        defaultValue: "Feedback Category",
                      })}
                      bordered={true}
                      size="large"
                      optionLabelProp="value"
                      onChange={(value) => {
                        categoryChange(value);
                      }}
                    >
                      {dataSource.map((option, idx) => (
                        <Select.Option key={idx} value={option.category}>
                          {option.category}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label={t("pages.security_questions.write_feedback", {
                      defaultValue: "Write your feedback",
                    })}
                    name={"suggestion"}
                    rules={[
                      {
                        required: true,
                        message: t("pages.security_questions.feedback_req", {
                          defaultValue: "Feedback is required",
                        }),
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder={t("pages.security_questions.feed_back", {
                        defaultValue: "Feedback",
                      })}
                      rows={8}
                      onChange={handleInputChange}
                      showCount
                      maxLength={250}
                      onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                    />
                  </Form.Item>{" "}
                  <div className="d-flex justify-content-end  mt-5">
                    <Button
                      className="primary-btn btn-view"
                      size="large"
                      type="primary"
                      htmlType="submit"
                    >
                      {t("buttons.submit_btn", {
                        defaultValue: "Submit",
                      })}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <Modal
        open={showModal}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{   margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>
          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                setShowModal(false);
                navigate("/dashboard");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
